import { render, staticRenderFns } from "./UserEditTabRestaurants.vue?vue&type=template&id=a9c42d4c&"
import script from "./UserEditTabRestaurants.vue?vue&type=script&lang=js&"
export * from "./UserEditTabRestaurants.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabRestaurants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports